import { SafeSessionStorage } from '#pplx/frontend/browser-storage/sessionStorage.js';
const POST_CHECKOUT_TIER_OVERRIDE_KEY = 'pplx.postCheckoutTierOverride';
export function getPostCheckoutTierOverride() {
    const tier = SafeSessionStorage.getItem(POST_CHECKOUT_TIER_OVERRIDE_KEY);
    return tier === 'pro' || tier === 'max' ? tier : undefined;
}
export function resolvePostCheckoutTier(tier) {
    const tierFromUrl = tier === 'pro' || tier === 'max' ? tier : undefined;
    return getPostCheckoutTierOverride() ?? tierFromUrl;
}
export function setPostCheckoutTierOverride(tier) {
    SafeSessionStorage.setItem(POST_CHECKOUT_TIER_OVERRIDE_KEY, tier);
}
export function clearPostCheckoutTierOverride() {
    SafeSessionStorage.removeItem(POST_CHECKOUT_TIER_OVERRIDE_KEY);
}
//# sourceMappingURL=postCheckoutTierOverride.js.map